import { render, staticRenderFns } from "./CoinCollector.vue?vue&type=template&id=2725a44b&"
import script from "./CoinCollector.vue?vue&type=script&lang=js&"
export * from "./CoinCollector.vue?vue&type=script&lang=js&"
import style0 from "./CoinCollector.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports